export enum TrackingType {
    GA = 'GA'
}
